import { EWatchlistCategory } from '@aqx-core/common/api/watchlist';
import { EAppThemeScheme } from '@aqx-core/common/theme';

import { EMixpanelWatchlistFilter, EMixpanlThemeScheme } from '../../types';

class EventPropertiesHelper {
  public mapWatchListEventProperties = (watchList: EWatchlistCategory) => {
    const actionEventMap: { [key in EWatchlistCategory]?: EMixpanelWatchlistFilter } = {
      [EWatchlistCategory.POPULAR]: EMixpanelWatchlistFilter.POPULAR,
      [EWatchlistCategory.TOP_LOSER]: EMixpanelWatchlistFilter.TOP_LOSER,
      [EWatchlistCategory.TOP_GAINER]: EMixpanelWatchlistFilter.TOP_GAINER,
      [EWatchlistCategory.FAVOURITES]: EMixpanelWatchlistFilter.FAVOURITES,
      [EWatchlistCategory.TOP_PICK]: EMixpanelWatchlistFilter.TOP_PICK,
      [EWatchlistCategory.ALL]: EMixpanelWatchlistFilter.ALL
    };
    return actionEventMap[watchList];
  };

  public mapThemeSchemeEventProperties = (themeScheme: EAppThemeScheme) => {
    const actionEventMap: { [key in EAppThemeScheme]?: EMixpanlThemeScheme } = {
      [EAppThemeScheme.DARK_SCHEME]: EMixpanlThemeScheme.DARK,
      [EAppThemeScheme.LIGHT_SCHEME]: EMixpanlThemeScheme.LIGHT,
      [EAppThemeScheme.SYSTEM_SCHEME]: EMixpanlThemeScheme.SYSTEM
    };
    return actionEventMap[themeScheme];
  };
}

const eventPropertiesHelper = new EventPropertiesHelper();
export default eventPropertiesHelper;
